"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.dashboard.search': 'Szukaj grup...',
    'whatsapp.dashboard.filterAll': 'Wszystkie',
    'whatsapp.dashboard.filterCritical': 'Krytyczne',
    'whatsapp.dashboard.filterWarning': 'Akcja',
    'whatsapp.dashboard.noGroupSelected': 'Wybierz grupę z listy po lewej stronie',
    'whatsapp.dashboard.statsMonitored': 'Monitorowane grupy',
    'whatsapp.dashboard.statsCritical': 'Krytyczne alerty',
    'whatsapp.dashboard.statsMembers': 'Uczestnicy grupy',
    'whatsapp.dashboard.statsStatus': 'Status grup',
    'whatsapp.dashboard.messagesConsole': 'Wiadomości',
    'whatsapp.dashboard.activityToday': 'Aktywność (Dziś)',
    'whatsapp.dashboard.sentimentGlobal': 'Sentyment globalny',
    'whatsapp.dashboard.aiStatus.good': 'Dobry',
    'whatsapp.dashboard.aiStatus.warning': 'Ostrzeżenie',
    'whatsapp.dashboard.aiStatus.critical': 'Krytyczny',
    'whatsapp.dashboard.aiStatus.neutral': 'Neutralny',
    'whatsapp.dashboard.selectGroupHint': 'Wybierz grupę, aby podejrzeć wiadomości',
    'whatsapp.dashboard.drawer.settings': 'Ustawienia grupy',
    'whatsapp.dashboard.drawer.members': 'Uczestnicy',
};
